import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { AlertService } from '../_services/alert.service';

declare let alertify : any;
declare let localforage : any;

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	loginForm! : FormGroup;
	loading = false;
	submitted = false;
	returnUrl! : string;

	constructor(
		private formBuilder : FormBuilder,
		private route : ActivatedRoute,
		private router : Router,
		private authenticationService : AuthenticationService,
		private alertService : AlertService
	) {
		// redirect to home if already logged in
		if (this.authenticationService.isAuthenticated) {
			this.router.navigate(['/']);
		}
	}

	ngOnInit() : void {
		this.loginForm = this.formBuilder.group({
			username: ['', Validators.required],
			password: ['', Validators.required]
		});

		// get return url from route parameters or default to '/'
		this.returnUrl = this.route.snapshot.queryParams['(returnUrl)'] || '/main';
		console.log('ngOnInit:' + this.returnUrl);
		document.body.className = 'bl-page-login';
	}
	// convenience getter for easy access to form fields
	get f() { return this.loginForm.controls; }

	onSubmit() {
		this.submitted = true;

		// stop here if form is invalid
		if (this.loginForm.invalid) {
			return;
		}
		this.loading = true;
		var self = this;

		this.authenticationService.login(this.f.username.value, this.f.password.value, function (userinfo : any) {
			if (userinfo) {
				console.log('Nav to main: user = ', userinfo);
				localforage.setItem('user', userinfo).then(function () {
					self.router.navigate(['/main']);
					self.loading = false;
				})
			}
			else {
				// self.alertService.error('');
				// self.router.navigate(['/demo']);

				self.loading = false;
				alertify.alert('Login', 'Đăng nhập không thành công. Vui lòng nhập chính xác mật khẩu!');
			}
		});
	}
}